import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
import Modal from './modal_doc_perusahaan';
import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

const title_form = "DATA PERUSAHAAN / GROUP";
const sub_title_form = ""
const tipedata = "PERUSAHAAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const hostcc = process.env.REACT_APP_API_HOST_COLOR_COMMENT;
const hostdrop = process.env.REACT_APP_API_HOST_DROPDOWN;
const hostdatcont = process.env.REACT_APP_API_HOST_DATA_CONT;

const API_COLUMN = mainhost + "PerusahaanColumn"
const API_VALUES = mainhost + "PerusahaanValue"
const API_Asset = mainhost + "AssetData"
const API_NewAsset = mainhost + "AssetNew"
const API_ActiveAsset = mainhost + "AssetActive"
const API_PercentAsset = mainhost + "AssetPercent"
const API_CREATE_ID = mainhost + "PerusahaanValue/New"
const API_STATUS_FILE = mainhost + "Cekstatusfile"
const API_UPDATE_COMMENT = hostcc + "Updatecomment"
const API_UPDATE_WARNA = hostcc + "ColorBrcontainers"
const API_UPDATE = mainhost + "PerusahaanValue_update"
const API_PASTE = mainhost + "PerusahaanForPaste"
const API_PT_DROPDOWN = mainhost + "PerusahaanForDropdown"

const API_AssetList = mainhost + "AssetList"
const API_AssetReportToko = mainhost + "AssetReportToko"
const API_AssetSumReportToko = mainhost + "AssetReportSumToko"
const API_AssetSumarryReportToko = mainhost + "AssetReportSumarryDToko"


const currentUrl = window.location.href;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const ReportToko = () => {
  const token = localStorage.getItem('token');

  const [TokenNew, setToken] = useState(null);
  const [AssetData, setAssetData] = useState(null);
  const [AssetReportToko, setAssetReportToko] = useState(null);
  const [AssetSumReportToko, setAssetSumReportToko] = useState(null);
  const [AssetSumarryReportToko, setAssetSumarryReportToko] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const config = apiConfig(token);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);
  const current_month = new Date().getMonth() + 1;

  const selectForBln = useRef(null);
  const selectForYearh = useRef(null);

  const year_local = localStorage.getItem("year_selected");
  const month_local = localStorage.getItem("month_selected");

  const year_selected = year_local ?  parseInt(year_local) : years[0]
  const month_selected = month_local ? parseInt(month_local) : current_month

  const [selectedYear, setSelectedYear] = useState(year_selected);
  const [selectedMonth, setSelectedMonth] = useState(month_selected);

  const months = [
    { value: '1', label: 'Januari' },
    { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mei' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ];
  

  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  const getAssetData = async () => {
    try {

      const formData = new FormData();
        formData.append('bln',month_selected);
        formData.append('thn',year_selected);
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_Asset}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getSUMReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetSumReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getSUMarryReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetSumarryReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleNewAsset = async () => {
    const newAsset = document.getElementById('new_asset').value;
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('asset', newAsset);
      const response = await axios.post(`${API_NewAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
      const asset_data = await getAssetData();
      setAssetData(asset_data);
      setIsLoading(false);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleActiveAsset = async (id) => {
    setIsLoading(true);
    AssetData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.active);
        if (item.active === '1') {
          item.active = '0';
        }
        else {
          item.active = '1';
        }
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      const response = await axios.post(`${API_PercentAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleChange = () => {

  }

  const handleMonthChange = (event) => {
    const value = event.target.value;
    let intValue;
    if (value.trim() !== '') {
         intValue = parseInt(value, 10);
        if (!isNaN(intValue)) {
        } else {
          intValue="";
        }
    } else {
      intValue="";
    }
    setSelectedMonth(intValue);
    localStorage.setItem("month_selected", intValue);
    window.location.reload();
  }

  const handleSelectYearChange = (year) => {
    const value = year.target.value;
    let intValue = parseInt(value, 10);
    if (!isNaN(intValue)) {
      setSelectedYear(intValue); // Update selected year state
      localStorage.setItem("year_selected", intValue); // Store in local storage
    } else {
      setSelectedYear(""); // Reset selected year state
      localStorage.removeItem("year_selected"); // Remove from local storage
    }
    window.location.reload();
  }

  const handlePercentAsset = async (id,e) => {
    console.log(e.target.value);
    console.log(id);
    setIsLoading(true);
    AssetData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.percentage);
        item.percentage = e.target.value;
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('percentage', e.target.value);
      const response = await axios.post(`${API_PercentAsset}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  $(selectForBln.current).on('change', handleMonthChange);
  $(selectForYearh.current).on('change', handleSelectYearChange);

  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    // const intervalId = setInterval(cekFile, 3600000);//1 jam

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      const asset_data = await getAssetData();
      setAssetData(asset_data);
      const report_toko = await getReportToko();
      setAssetReportToko(report_toko);
      const sum_report_toko = await getSUMReportToko();
      setAssetSumReportToko(sum_report_toko);
      const sumarry_report_toko = await getSUMarryReportToko();
      setAssetSumarryReportToko(sumarry_report_toko);
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;
      console.log('asset',AssetData);

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);

      $(selectForBln.current).on('change', handleMonthChange);
      $(selectForYearh.current).on('change', handleSelectYearChange);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const formatNumberWithoutDecimals = (num) => {
    // convert num into float
    num = parseFloat(num);
    return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  return (
    <div>
      <HeaderMenu title={"Report Toko"} subtitle={"Report Toko"} />
      {/* <ToastContainer /> */}
      
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <select style={selectStyle120} ref={selectForBln} className="js-example-basic-single style-select-report" value={selectedMonth || ""} onChange={handleChange}>
                <option value="">-PILIH-</option>
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <select style={selectStyle120} ref={selectForYearh} className="js-example-basic-single style-select-report" value={selectedYear} onChange={handleChange}>
                  <option value="">-PILIH-</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>  
            </tr>
          </tbody>
        </table>

      </div>
      <div className="containers" style={{ width : "100%"}}>

	<ul className="tabs" style={{ width: "100%"}}>
		<li className="tab-link current" data-tab="tab-1">Summary</li>
		<li className="tab-link" data-tab="tab-2">Sum</li>
		<li className="tab-link" data-tab="tab-3">Detail</li>
	</ul>

	<div id="tab-1" className="tab-content current">
          <div style={{ textAlign: 'center', overflow:'auto', height:'540px',}}>
            <table className='table table-bordered'>
              <thead>
                <tr>
                  <th>Keterangan</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              Object.keys(AssetSumarryReportToko).map((item,index) => (
                Object.keys(AssetSumarryReportToko[item]).map((item1, index) => (
                <tr key={index}>
                        <td style={{ textAlign:'left'}}>{item1}</td> 
                        <td style={{ textAlign:'right'}}>Rp. {formatNumberWithoutDecimals(AssetSumarryReportToko[item][item1])}</td>
                    </tr>
                ))
              ))
              }
            </tbody>
            </table>
          </div>
  </div>
	<div id="tab-2" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'540px',}}>
            <table>
              <tbody>
              <tr>
            { isLoading ? <td>Loading...</td> :
            Object.keys(AssetSumReportToko).map((key) => (
              <td keys={"tab2"+key}  style={{ verticalAlign:"top", margin:"2px",width:"320px"}}>
              <table style={{ border:"1px solid black",width:"280px"}} className="table table-bordered">
                <thead>
                <tr key="tab2{key}">
                  <th colSpan="4">{key}</th>
                </tr>
                <tr key="tab{key}2">
                  <th>Kategori</th>
                  <th>Jumlah</th>
                </tr>
                </thead>
                <tbody>
                {Object.keys(AssetSumReportToko[key]).map((item, index) => (
                  <tr key={"Tab"+index}>
                    { item == 'Total' ? 
                      <td style={{ textAlign:'center'}}>Total</td> 
                      : 
                      <td style={{ textAlign:'left'}}>{item}</td> 
                    }
                    { item == 'Total' ? 
                      <td style={{ textAlign: "right", fontWeight:"bold"}}>{formatNumberWithoutDecimals(AssetSumReportToko[key][item])}</td>
                      :
                      <td style={{ textAlign: "right"}}>{formatNumberWithoutDecimals(AssetSumReportToko[key][item])}</td>
                    }
                  </tr>
                ))}
                </tbody>
              </table>
              </td>
            ))
            }
            </tr>
            </tbody>
            </table>
            </div>
          </div>
	<div id="tab-3" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'540px',}}>
            <table>
              <tbody>
              <tr>
          { isLoading ? <td>Loading...</td> : 
          Object.keys(AssetReportToko).map((key) => (
            <td keys={"tab3"+key} style={{ verticalAlign:"top", margin:"2px",width:"380px"}}>
            <table style={{ border:"1px solid black",width:"380px"}} className="table table-bordered">
              <thead>
              <tr>
                <th colSpan="4">{key}</th>
              </tr>
              <tr>
                <th style={{ width:"50px"}}>Kas</th>
                <th style={{ width:"120px"}}>Account</th>
                <th style={{ width:"200px"}}>Sub Account</th>
                <th style={{ width:"120px"}}>Jumlah</th>
              </tr>
              </thead>
              <tbody>
              {AssetReportToko[key].map((item, index) => (
                <tr>
                  <td style={{ width:"50px"}}>{item.kas}</td>
                  <td style={{ width:"120px"}}>{item.kategori}</td>
                  <td style={{ width:"200px"}}>{item.keterangan}</td>
                  <td style={{ textAlign: "right", width:"120px"}}>{formatNumberWithoutDecimals(item.nominal_idr)}</td>
                </tr>
              ))}
              </tbody>
            </table>
            </td>
          ))
          }
          </tr>
          </tbody>
          </table>
          
          </div>  
  </div>

</div>


    </div>
  );
};


export default ReportToko;